



























import Vue from 'vue'

import validationRules from '@/utils/validation'

export default Vue.extend({
  name: 'SwayOfferNotificationModal',

  data() {
    return {
      emailAddress: null,
      emailRules: validationRules.emailRules,
    }
  },

  methods: {
    handleNotificationDataEntered() {
      if (!this.$refs.notificationDataForm.validate()) return

      this.$emit('sway-offer-notification-data-entered', { email: this.emailAddress })
    },
  },
})
